// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__kXPeQ","rightAdornment":"Header_rightAdornment__1K2B-"};